import { NumberExt } from '../../util';
import { bodyAttr } from './util';
import { Base } from '../base';
const CYLINDER_TILT = 10;
export const Cylinder = Base.define({
    shape: 'cylinder',
    markup: [
        {
            tagName: 'path',
            selector: 'body',
        },
        {
            tagName: 'ellipse',
            selector: 'top',
        },
        {
            tagName: 'text',
            selector: 'label',
        },
    ],
    attrs: {
        body: Object.assign(Object.assign({}, bodyAttr), { lateralArea: CYLINDER_TILT }),
        top: Object.assign(Object.assign({}, bodyAttr), { refCx: '50%', refRx: '50%', cy: CYLINDER_TILT, ry: CYLINDER_TILT }),
    },
    attrHooks: {
        lateralArea: {
            set(t, { refBBox }) {
                const isPercentage = NumberExt.isPercentage(t);
                if (isPercentage) {
                    // tslint:disable-next-line
                    t = parseFloat(t) / 100;
                }
                const x = refBBox.x;
                const y = refBBox.y;
                const w = refBBox.width;
                const h = refBBox.height;
                // curve control point variables
                const rx = w / 2;
                const ry = isPercentage ? h * t : t;
                const kappa = 0.551784;
                const cx = kappa * rx;
                const cy = kappa * ry;
                // shape variables
                const xLeft = x;
                const xCenter = x + w / 2;
                const xRight = x + w;
                const ySideTop = y + ry;
                const yCurveTop = ySideTop - ry;
                const ySideBottom = y + h - ry;
                const yCurveBottom = y + h;
                // return calculated shape
                const data = [
                    'M',
                    xLeft,
                    ySideTop,
                    'L',
                    xLeft,
                    ySideBottom,
                    'C',
                    x,
                    ySideBottom + cy,
                    xCenter - cx,
                    yCurveBottom,
                    xCenter,
                    yCurveBottom,
                    'C',
                    xCenter + cx,
                    yCurveBottom,
                    xRight,
                    ySideBottom + cy,
                    xRight,
                    ySideBottom,
                    'L',
                    xRight,
                    ySideTop,
                    'C',
                    xRight,
                    ySideTop - cy,
                    xCenter + cx,
                    yCurveTop,
                    xCenter,
                    yCurveTop,
                    'C',
                    xCenter - cx,
                    yCurveTop,
                    xLeft,
                    ySideTop - cy,
                    xLeft,
                    ySideTop,
                    'Z',
                ];
                return { d: data.join(' ') };
            },
        },
    },
});
//# sourceMappingURL=cylinder.js.map